/**
 * Owner 2026-10-24 10:40 — „Dopożycz” from several suppliers: „fajnie byłoby móc wybrać ileś od jednego, ileś od drugiego,
 * tak żeby zrealizować całe dopożyczenie od dostawców. Domyślnie od pierwszego bierzemy wszystko, co ma, i resztę
 * dopożyczamy dalej.” His answers: the supplier who has the MOST goes first (as few suppliers as possible); a supplier
 * without a known stock goes last and takes the rest („ilość niepotwierdzona”); too few in all — as much as possible.
 */

/** One supplier's position offered for the item (`GET …/split`; rule 7a: price / stock absent when not seen). */
export type SplitRow = {
  priceId: string;
  supplierId: string;
  supplierName: string;
  /** `exact`: linked to our item; `similar`: only the name matches — never chosen by itself („Połącz z moim”). */
  match: 'exact' | 'similar';
  linkable?: boolean;
  priceDayGrosze?: number;
  stock?: number | null;
  taken?: number;
  /** Still free at the supplier for these days: a number (the cap), null (not known: no cap), undefined (not seen). */
  available?: number | null | undefined;
  /** Owner 2026-10-24 16:15: the days with the supplier's quantity typed by hand (only with the quantities seen). */
  manual?: Array<{ day: string; quantity: number }>;
};

/** The default quantity per position (`priceId`) for `need` pieces, and what is still missing. */
export function defaultSplit(rows: readonly SplitRow[], need: number): { quantities: Map<string, number>; missing: number } {
  const quantities = new Map(rows.map((r) => [r.priceId, 0]));
  const exact = rows.filter((r) => r.match === 'exact');
  const known = exact.filter((r) => typeof r.available === 'number').sort((a, b) => (b.available as number) - (a.available as number));
  const unknown = exact.filter((r) => typeof r.available !== 'number');
  let left = Math.max(0, need);
  for (const r of known) {
    const take = Math.min(left, r.available as number);
    quantities.set(r.priceId, take);
    left -= take;
  }
  if (left > 0 && unknown.length > 0) {
    quantities.set(unknown[0]!.priceId, left);
    left = 0;
  }
  return { quantities, missing: left };
}

/** „Razem: X z N · brakuje jeszcze M” and the cost Σ pieces × price × days (null when a price with pieces is not seen). */
export function splitSummary(rows: readonly SplitRow[], quantities: ReadonlyMap<string, number>, need: number, days: number | null): { total: number; missing: number; costGrosze: number | null } {
  let total = 0;
  let cost: number | null = 0;
  for (const r of rows) {
    const q = quantities.get(r.priceId) ?? 0;
    if (q <= 0) continue;
    total += q;
    cost = cost === null || r.priceDayGrosze === undefined || days === null ? null : cost + q * r.priceDayGrosze * days;
  }
  return { total, missing: Math.max(0, need - total), costGrosze: cost };
}
